import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface ClientIntegration {
  id: number;
  client_id: number;
  platform: string;
  credentials: Record<string, any>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClientIntegrationList {
  id: number;
  is_active: boolean;
  platform: string;
}

export const clientIntegrationService = {
  getClientIntegrations: async (clientId: number): Promise<ClientIntegration[]> => {
    const token = localStorage.getItem('token');
    const response = await api.get(`${API_BASE_URL}/client-integrations/${clientId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getClientIntegrationsList: async (clientId: number): Promise<ClientIntegrationList[]> => {
    const token = localStorage.getItem('token');
    const response = await api.get(`${API_BASE_URL}/client-integrations/${clientId}/list`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getIntegrationByPlatform: async (clientId: number, platform: string): Promise<ClientIntegration> => {
    const token = localStorage.getItem('token');
    const response = await api.get(`${API_BASE_URL}/client-integrations/${clientId}/${platform}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  createIntegration: async (clientId: number, platform: string, credentials: Record<string, any>, isActive: boolean = true): Promise<ClientIntegration> => {
    const token = localStorage.getItem('token');
    const response = await api.post(
      `${API_BASE_URL}/client-integrations/${clientId}`,
      { platform, credentials, is_active: isActive },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  updateIntegration: async (clientId: number, platform: string, credentials: Record<string, any>, isActive?: boolean): Promise<ClientIntegration> => {
    const token = localStorage.getItem('token');
    const response = await api.put(
      `${API_BASE_URL}/client-integrations/${clientId}/${platform}`,
      { credentials, is_active: isActive },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  deleteIntegration: async (clientId: number, platform: string): Promise<void> => {
    const token = localStorage.getItem('token');
    await api.delete(`${API_BASE_URL}/client-integrations/${clientId}/${platform}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  postEbayOAuthCode: async (payload: { code: string; state?: string }): Promise<unknown> => {
    const token = localStorage.getItem('token');
    const response = await api.post(
      `${API_BASE_URL}/client-integrations/ebay-code`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  }
};
